export const escapeAlgoliaFilterValue = value =>
  String(value)
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')

export const buildObjectIdFilter = objectId =>
  `objectID:"${escapeAlgoliaFilterValue(objectId)}"`

export const buildActivityIdsFilter = activityIds =>
  activityIds.map(buildObjectIdFilter).join(' OR ')
